import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import {
  IOrderState,
  reducer as orderReducer,
} from '../reducers/order-store.reducer';

export const DATA_ACCESS_ORDER_FEATURE_KEY = 'order';
export interface IOrderFeatureState {
  order: IOrderState;
}

export const reducers: ActionReducerMap<IOrderFeatureState> = {
  order: orderReducer,
};

export const getOrderFeatureState = createFeatureSelector<IOrderFeatureState>(
  DATA_ACCESS_ORDER_FEATURE_KEY
);
